import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

const firebaseConfig = {
  apiKey: (process.env.REACT_APP_FIREBASE_API_KEY || '').trim(),
  authDomain: (process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || 'bhairav-aradhya.firebaseapp.com').trim(),
  projectId: (process.env.REACT_APP_FIREBASE_PROJECT_ID || 'bhairav-aradhya').trim(),
  storageBucket: (process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || 'bhairav-aradhya.firebasestorage.app').trim(),
  messagingSenderId: (process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '126248214025').trim(),
  appId: (process.env.REACT_APP_FIREBASE_APP_ID || '1:126248214025:web:53e0ce7a564b3607aca2d8').trim(),
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();